// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2tD1r","left":"InfoRow_left__37XLB"};